import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';

import { ModalService } from '../../../services/common/modal.service';
import { NotyService } from '../../../services/common/noty.service';
import { TagService } from '../../../services/common/tag.service';

@Component({
  selector: 'app-contact-tags',
  templateUrl: './contact-tags.component.html',
  styleUrls: ['./contact-tags.component.scss'],
})
export class ContactTagsComponent implements OnInit, OnChanges {
  /**
   * Contact Id for tags
   */
  @Input() contactId: number;

  /**
   * New tag
   * @type {string | null}
   */
  newTag: string | null;

  /**
   * List of tags
   * @type {Array<string>}
   */
  tags: Array<string> = [];

  /**
   * Inidcates if tags are loading
   * @type {boolean}
   */
  tags_loading: boolean = true;

  /**
   * Indicates if new tag form is to be shown
   * @type {boolean}
   */
  showNewTagForm: boolean = false;

  /**
   * Inject dependent services
   * @param {ModalService} private modalService Display confirm modals
   * @param {NotyService}  private notyService  Service for notifications
   * @param {TagService}   private tagService   Service for Tag Resource
   */
  constructor(private modalService: ModalService, private notyService: NotyService, private tagService: TagService) {}

  // Component lifecycle methods
  ngOnInit() {}

  /**
   * Called when component variables change
   * @param {SimpleChanges} changes Object with variables which have changed
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && changes.contactId.currentValue) this.loadTags();
  }

  // Component methods

  /**
   * Load tags
   */
  loadTags() {
    this.tags_loading = true;
    this.tagService.index({ contact_id: this.contactId }).then((response_json) => {
      this.tags = response_json;
      this.tags_loading = false;
    });
  }

  /**
   * Add new tag
   */
  addTag() {
    if (this.newTag)
      this.tagService
        .create({ contact_id: this.contactId, tag: { tag: this.newTag } })
        .then((response_json) => {
          if (response_json.success) {
            this.notyService.notify(response_json.text || 'Tag added', 'success', 5000, 'topRight');
            this.newTag = null;
            this.loadTags();
            this.showNewTagForm = false;
          } else this.notyService.notify(response_json.text || 'Error adding tag', 'error', 5000, 'topRight');
        })
        .catch(() => {
          this.notyService.notify('Error adding tag', 'error', 5000, 'topRight');
        });
    else this.notyService.notify('A tag needs to be entered', 'warning', 5000, 'topRight');
  }

  /**
   * Remove tag
   * @param {number} index [description]
   */
  removeTag(tag: string, index: number) {
    this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-danger';
    this.modalService.confirmDialogComponent.open(`<p>Delete Tag - <strong class='text-danger'>${tag}</strong></p>`).result.then(
      (result) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
        if (result == 'confirmed') {
          this.tagService
            .delete({ contact_id: this.contactId, tag: { tag: tag } })
            .then((response_json) => {
              if (response_json.success) {
                this.notyService.notify(response_json.text || 'Tag deleted', 'info', 5000, 'topRight');
                this.loadTags();
              } else this.notyService.notify(response_json.text || 'Error deleting tag', 'error', 5000, 'topRight');
            })
            .catch(() => {
              this.notyService.notify('Error deleting tag', 'error', 5000, 'topRight');
            });
        }
      },
      (reason) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
      }
    );
  }
}
